
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AllUsers from '@/components/accounts/permissions/AllUsers.vue';
@Component({
	components: {
		AllUsers,
	},
})
export default class Admin extends Vue {}
